module.exports = __webpack_public_path__ + "img/guide4.29f1a2eb.jpg";